import {
  AddressInputs as SharedAddressInputs,
  type AddressInputsProps as SharedAddressInputsProps,
} from "shared-web/components/composite/input/AddressInputs"

import { useCountry } from "hooks/useCountry"

// `defaultCountry` and `enableCrossCountry` are derived here from the company
// country, so callers supply neither.
interface AddressInputsProps
  extends Omit<
    SharedAddressInputsProps,
    "defaultCountry" | "enableCrossCountry"
  > {
  allowCrossCountry?: boolean
}

export function AddressInputs({
  allowCrossCountry,
  ...props
}: AddressInputsProps) {
  const defaultCountry = useCountry()

  return (
    <SharedAddressInputs
      {...props}
      defaultCountry={defaultCountry}
      enableCrossCountry={allowCrossCountry}
    />
  )
}
